import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";

import apiRoutes from "../../../utils/apiRoutes";
import { getHeaders } from "../../../utils/apiHelper";
import LoadingIndicator from "../../Common/components/LoadingIndicator";
import SettingHeader from "../SettingHeader";
import PetrolAmountForm from "./PetrolAmountForm";
import PetrolAmountTable from "./PetrolAmountTable";

const defaultPermissionStatus = {
  isAddNew: false,
  isEdit: false,
};

const getResponseData = async (response) => {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
};

export default class PetrolAmount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isSaving: false,
      isAddNew: false,
      isEdit: false,
      history: [],
      editData: null,
      permissionStatus: defaultPermissionStatus,
    };
  }

  componentDidMount() {
    this.loadHistory();
  }

  loadHistory = async () => {
    this.setState({ isLoading: true });

    try {
      const response = await fetch(apiRoutes.petrolAmountHistory, {
        headers: getHeaders(),
      });
      const responseData = await getResponseData(response);

      if (!response.ok) {
        throw new Error(
          responseData?.message || "Unable to load petrol amount history."
        );
      }

      const data = responseData?.data;
      this.setState({
        history: Array.isArray(data?.history) ? data.history : [],
        permissionStatus: {
          isAddNew: Boolean(data?.permissionStatus?.isAddNew),
          isEdit: Boolean(data?.permissionStatus?.isEdit),
        },
        isLoading: false,
      });
    } catch (error) {
      this.setState({ isLoading: false });
      this.showError(
        error.message || "Unable to load petrol amount history."
      );
    }
  };

  setupForm = () => {
    if (!this.state.permissionStatus.isAddNew) return;

    this.setState({
      isAddNew: true,
      isEdit: false,
      editData: null,
    });
  };

  goToEditForm = (setting) => {
    if (!this.state.permissionStatus.isEdit) return;

    this.setState({
      isAddNew: false,
      isEdit: true,
      editData: setting,
    });
  };

  handleSave = async (payload) => {
    if (this.state.isSaving) return;

    const { isEdit, editData } = this.state;
    if (isEdit && (!Number.isInteger(Number(editData?.id)) || +editData.id <= 0)) {
      return this.showError("Unable to update an invalid petrol amount setting.");
    }

    const url = isEdit
      ? apiRoutes.petrolAmountEdit(editData.id)
      : apiRoutes.petrolAmount;

    this.setState({ isSaving: true });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: getHeaders(false),
        body: JSON.stringify(payload),
      });
      const responseData = await getResponseData(response);

      if (!response.ok) {
        throw new Error(
          responseData?.message || "Unable to save the petrol amount setting."
        );
      }

      this.setState({
        isSaving: false,
        isAddNew: false,
        isEdit: false,
        editData: null,
      });
      toast.success(
        isEdit
          ? "Petrol amount setting updated successfully."
          : "Petrol amount setting created successfully."
      );
      await this.loadHistory();
    } catch (error) {
      this.setState({ isSaving: false });
      this.showError(
        error.message || "Unable to save the petrol amount setting."
      );
    }
  };

  showError = (message) => {
    toast.error(message);
  };

  render() {
    const {
      isLoading,
      isSaving,
      isAddNew,
      isEdit,
      history,
      editData,
      permissionStatus,
    } = this.state;
    const isList = !isAddNew && !isEdit;

    return (
      <div className="petrol-amount-setting border-bottom white-bg dashboard-header">
        <ToastContainer position={toast.POSITION.TOP_RIGHT} />
        <SettingHeader
          pageTitle="Petrol Amount"
          setupForm={this.setupForm}
          isAddNew={isAddNew}
          isEdit={isEdit}
          permission={permissionStatus}
        />

        {isList && isLoading && <LoadingIndicator />}
        {isList && !isLoading && (
          <PetrolAmountTable
            data={history}
            canEdit={permissionStatus.isEdit}
            onEdit={this.goToEditForm}
          />
        )}
        {(isAddNew || isEdit) && (
          <PetrolAmountForm
            data={isEdit ? editData : null}
            isEdit={isEdit}
            isSaving={isSaving}
            onSave={this.handleSave}
          />
        )}
      </div>
    );
  }
}
